import { useParams } from 'react-router';

// Tomra single-QR flow: `/recycle/tomra/<campaignId>/v2/<sessionId>`
export function useIsSingleQrFlow() {
  const { campaignId, token } = useParams();

  return (
    token != undefined &&
    window.location.pathname.includes(`/${campaignId}/v2/${token}`)
  );
}

export function useRouteName() {
  const { campaignType, campaignId, token } = useParams();
  const isSingleQrFlow = useIsSingleQrFlow();

  const routeName = (
    route: string,
    options?: { searchParams?: URLSearchParams }
  ) => {
    // For tomra the token is optional, for token and recycling campaigns it should be there
    const hasToken = token != undefined;
    const tokenPath = hasToken ? `${isSingleQrFlow ? '/v2' : ''}/${token}` : '';

    const regex = new RegExp(
      String.raw`/${campaignType}/${campaignId}${tokenPath}.*`,
      'g'
    );
    // In most cases this will be `/recycle`, but it can also be empty for 'cashback-brands'
    const prefix = window.location.pathname
      .replace(regex, '')
      .replace(/\/$/, ''); // strips trailing slash
    const url =
      `${prefix}/${campaignType}/${campaignId}${tokenPath}${route}`.replace(
        /\/$/,
        ''
      ); // strips trailing slash

    if (options?.searchParams) {
      return `${url}?${options.searchParams.toString()}`;
    }

    return url;
  };

  return routeName;
}
